<template>
  <BaseNotification
    v-bind="$attrs"
    v-on="$listeners"
    :show="message.length > 0"
    :styleConfig="styleConfig"
  >
    <template v-slot:left>
      <slot name="left" />
    </template>
    <template v-slot:center>
      {{ message }}
    </template>
    <template v-slot:right>
      <slot name="right" />
    </template>
  </BaseNotification>
</template>

<script>
  import BaseNotification from '@base/v2/base-notification'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'NotificationPrimary',
    inheritAttrs: false,
    components: {
      BaseNotification,
    },
    data: function () {
      return {
        styleConfig: {
          center: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.lg,
          },
          container: {
            borderRadius: Layout.space.sm,
            height: 'fit-content',
            margin: '0 auto 2px auto',
            minHeight: '50px',
            padding: `${Layout.space.md} ${Layout.space.lg}`,
            width: 'fit-content',
          },
          left: {},
          right: {},
          root: {
            backgroundColor: 'transparent',
            bottom: 0,
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.center,
        {
          color: this.color.light1(),
        },
      );

      Object.assign(
        this.styleConfig.container,
        {
          backgroundColor: this.color.action1(),
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      ...mapState({
        message: state => state.notification.message,
      }),
    },
  };
</script>
